import { useEffect, useState } from "react";

/**
* Custom hook to manage and persist the selected product layout style.
* Stores the selected layout in sessionStorage under the key "productLayoutCatermat".
*
* @returns {{
*   productLayout: string; // Current selected layout style, e.g., "block"
*   setProductLayout: React.Dispatch<React.SetStateAction<string>>; // Setter to update the layout style
* }}
*/
export const useProductLayout = () => {
    // Selected product layout style
    const [productLayout, setProductLayout] = useState(() => {
        const saved = sessionStorage.getItem("productLayoutCatermat");
        return saved ? JSON.parse(saved) : "block";
    });
    // Save to sessionStorage every time the selected layout style changes
    useEffect(() => {
        sessionStorage.setItem("productLayoutCatermat", JSON.stringify(productLayout));
    }, [productLayout]);
    
    return {productLayout, setProductLayout}
}